import React, { useEffect, useMemo, useRef, useState } from "react";
import Backa from "../MyImages/Backa.jpg";
import DRLogo from "../MyImages/ooo.png";
import { Link } from "react-router-dom";

import WholeHotel from "../MyImages/WholeHotel.jpg";
import OceanOneeee from "../MyImages/OceanOneee.png";
import restaurants from "../MyImages/restaurantss.jpg";
import LaOc from "../MyImages/LaOc.png";
import LastOnyy from "../MyImages/LastOnyy.jpg";

// Ensembles images
import AnsemblePic from "../MyImages/AnsemblePic.JPG";
import OrchestraPic from "../MyImages/OrchestraPic.jpg";
import SectionalPic from "../MyImages/Sectional.jpg";

// Excursions + activities images
import IslaSaona from "../MyImages/isla-saona.jpg";
import ResortActivities from "../MyImages/ResortActivites.jpg";
import Shopping from "../MyImages/Shopping.jpg";

// Faculty images
import ElEddy from "../MyImages/ElEddy.jpg";
import Eljose from "../MyImages/Eljose.avif";
import ElRuben from "../MyImages/ElRuben.jpg";
import LaSusan from "../MyImages/LaSusan.jpg";

import { motion } from "framer-motion";

const HomiePagie = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 16, filter: "blur(10px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.9, ease: "easeOut" },
    },
  };

  const softIn = {
    hidden: { opacity: 0, y: 10, scale: 0.99, filter: "blur(12px)" },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      filter: "blur(0px)",
      transition: { duration: 0.85, ease: "easeOut" },
    },
  };

  const stagger = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12 } },
  };

  // ================= FACULTAD (DATA) =================
  const faculty = useMemo(
    () => [
      {
        name: "Eddy Marcano",
        img: ElEddy,
        role: ["MAESTRO", "DÉCADAS DE EXPERIENCIA"],
        dot: "bg-amber-500",
        bar: "from-amber-500 via-yellow-200 to-transparent",
      },
      {
        name: "Jose Nieto",
        img: Eljose,
        role: ["INTÉRPRETE", "LÍDER DE SECCIÓN"],
        dot: "bg-blue-600",
        bar: "from-blue-600 via-sky-300 to-transparent",
      },
      {
        name: "Ruben Siman",
        img: ElRuben,
        role: ["COACHING", "MENTORÍA"],
        dot: "bg-red-600",
        bar: "from-red-600 via-rose-300 to-transparent",
      },
      {
        name: "Susan Siman",
        img: LaSusan,
        role: ["NIVEL GRAMMY", "ARTE"],
        dot: "bg-amber-500",
        bar: "from-amber-500 via-yellow-200 to-transparent",
      },
    ],
    []
  );

  // Duplicamos para loop seamless
  const loopFaculty = useMemo(() => [...faculty, ...faculty], [faculty]);

  // ================= AUTO-CAROUSEL SEAMLESS =================
  const firstCardRef = useRef(null);
  const rafRef = useRef(null);
  const lastTRef = useRef(0);

  const [paused, setPaused] = useState(false);
  const [gapPx, setGapPx] = useState(20);
  const [cardW, setCardW] = useState(520);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const measure = () => {
      const el = firstCardRef.current;
      if (!el) return;
      const w = el.getBoundingClientRect().width;
      if (w > 0) setCardW(w);
      setGapPx(20); // gap-5
    };

    measure();
    const ro = new ResizeObserver(measure);
    if (firstCardRef.current) ro.observe(firstCardRef.current);
    window.addEventListener("resize", measure);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  useEffect(() => {
    const baseLen = faculty.length;
    const baseWidth = baseLen * (cardW + gapPx);
    const speed = 22; // px/seg (lento)

    const tick = (t) => {
      if (!lastTRef.current) lastTRef.current = t;
      const dt = (t - lastTRef.current) / 1000;
      lastTRef.current = t;

      if (!paused) {
        setOffset((prev) => {
          let next = prev + speed * dt;
          if (next >= baseWidth) next -= baseWidth;
          return next;
        });
      }

      rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
      lastTRef.current = 0;
    };
  }, [paused, faculty.length, cardW, gapPx]);

  return (
    <div className="w-full min-h-screen text-white">
      {/* ================= NAVBAR ================= */}
      <nav className="fixed top-0 left-0 w-full z-50">
  {/* Wrap everything so the background can sit behind content WITHOUT -z-10 */}
  <div className="relative">
    {/* Background layer (iPhone/Safari friendly) */}
    <div
      className="absolute inset-0 z-0 bg-black/35 md:bg-white/10 md:backdrop-blur-md border-b border-white/20"
      style={{ transform: "translateZ(0)" }} // helps prevent iOS “dark square” repaint bug
    />

    {/* Content layer */}
    <div className="relative z-10 mx-auto flex max-w-7xl items-center justify-between px-6 md:px-10 py-5">
      <motion.h1
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="text-sm md:text-base font-semibold tracking-[0.22em] drop-shadow-[0_10px_25px_rgba(0,0,0,0.25)]"
      >
        SIMANOF FESTIVAL
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.08 }}
        className="hidden md:flex items-center gap-5 lg:gap-7 text-xs lg:text-sm tracking-wide"
      >
        {[
          { label: "Resort", href: "#about" },
          { label: "Experiencia", href: "#experience" },
          { label: "Excursiones", href: "#excursions" },
          { label: "Facultad", href: "#faculty" },
          { label: "Competencia", href: "#competition" },
          { label: "Precios", href: "#pricing" },
          { label: "Aplicar", href: "#apply" },
          { label: "Contratos", href: "/contratos", route: true },
        ].map((item) => (
          item.route ? (
            <Link
              key={item.label}
              to={item.href}
              className="rounded-full border border-white/35 bg-white/10 px-4 py-2 font-semibold text-white hover:bg-white/20 transition drop-shadow-[0_10px_25px_rgba(0,0,0,0.25)]"
            >
              {item.label}
            </Link>
          ) : (
            <a
              key={item.label}
              href={item.href}
              className="text-white/95 hover:text-white transition drop-shadow-[0_10px_25px_rgba(0,0,0,0.25)]"
            >
              {item.label}
            </a>
          )
        ))}
      </motion.div>
    </div>
  </div>
</nav>

      {/* ================= HERO ================= */}
      <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
  <img
    src={Backa}
    alt="Fondo República Dominicana"
    className="absolute inset-0 w-full h-full object-cover scale-[1.02]"
  />
  <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/0 to-black/10" />

  {/* Soft bottom fade */}
  <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-t from-black/35 via-black/10 to-transparent" />

  <div className="relative z-10 flex flex-col items-center text-center px-6 md:px-10 pt-20 w-full">
    {/* LOGO (BIG) + CROPPED */}
    <div className="w-[95%] max-w-[1700px] overflow-hidden h-[520px] md:h-[650px]">
  <motion.img
    src={DRLogo}
    alt="Logo Festival República Dominicana"
    className="w-full h-full object-contain object-center -translate-y-10 md:-translate-y-16 drop-shadow-[0_25px_70px_rgba(0,0,0,0.25)]"
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 1, ease: "easeOut" }}
  />
</div>

    {/* TAGLINE right below logo */}
    <motion.p
      variants={fadeUp}
      initial="hidden"
      animate="show"
      className="mt-4 text-base md:text-xl text-white/85 max-w-2xl drop-shadow-[0_16px_45px_rgba(0,0,0,0.22)]"
    >
      Una experiencia orquestal transformadora en Punta Cana.
    </motion.p>

    {/* APPLY BUTTON (your style unchanged) */}
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
      className="mt-6"
    >
     <Link
  to="/tour-form"
  className="inline-flex items-center justify-center rounded-md px-11 py-3.5 
  border border-white/60 bg-black/30 backdrop-blur-md
  hover:bg-black/45 hover:border-white
  transition duration-300 tracking-[0.22em] text-sm
  transform hover:scale-[1.06] active:scale-[0.98]"
>
  APLICA AHORA
</Link>
    </motion.div>
  </div>

  {/* White wave */}
  <div className="absolute bottom-[-1px] left-0 right-0">
    <svg viewBox="0 0 1440 120" className="w-full h-[110px]" preserveAspectRatio="none">
      <path
        d="M0,64 C240,110 420,110 720,70 C1020,30 1200,40 1440,68 L1440,120 L0,120 Z"
        fill="white"
      />
    </svg>
  </div>
</section>

      {/* ================= RESORT SECTION ================= */}
      <section id="about" className="relative w-full bg-white text-slate-900 py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 opacity-[0.55] bg-[radial-gradient(circle_at_18%_20%,rgba(59,130,246,0.10),transparent_45%),radial-gradient(circle_at_85%_80%,rgba(220,38,38,0.09),transparent_45%)]" />
        </div>

        <div className="relative mx-auto max-w-7xl px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            <motion.div
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.25 }}
              className="lg:col-span-5 lg:sticky lg:top-28"
            >
              <motion.div
                variants={fadeUp}
                className="inline-flex items-center gap-3 rounded-full border border-slate-200 bg-white/75 px-4 py-2 backdrop-blur-md shadow-sm"
              >
                <span className="h-2 w-2 rounded-full bg-blue-600" />
                <span className="text-xs tracking-[0.28em] text-slate-700">
                  MAR AZUL &amp; ARENA • TODO INCLUIDO
                </span>
              </motion.div>

              <motion.h3 variants={fadeUp} className="mt-6 text-3xl md:text-5xl font-light tracking-wide">
                Hospedaje frente al Mar en Punta Cana
              </motion.h3>

              <motion.p variants={fadeUp} className="mt-4 text-slate-600 text-base md:text-lg leading-relaxed">
                Un “home base” premium para el festival—comodidad, enfoque y comunidad. La comida todo incluido y el
                acceso al resort son parte de la experiencia.
              </motion.p>

              <motion.div variants={fadeUp} className="mt-8 flex items-center gap-4">
                <img src={OceanOneeee} alt="Ocean Blue" className="h-10 w-auto" />
                <div className="h-[3px] flex-1 rounded-full bg-gradient-to-r from-blue-600 via-slate-200 to-red-600" />
              </motion.div>

              <motion.div variants={fadeUp} className="mt-8 grid gap-3">
                {[
                  "Comidas todo incluido (desayuno, almuerzo, cena)",
                  "Amenidades del resort frente al mar",
                  "Un solo hospedaje para todo el grupo",
                ].map((t, i) => (
                  <div
                    key={t}
                    className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-white/70 backdrop-blur-md px-5 py-4 shadow-[0_18px_50px_rgba(2,6,23,0.06)]"
                  >
                    <span
                      className={`mt-1.5 h-2 w-2 rounded-full ${
                        i === 0 ? "bg-blue-600" : i === 1 ? "bg-slate-400" : "bg-red-600"
                      }`}
                    />
                    <p className="text-slate-700 text-sm md:text-base">{t}</p>
                  </div>
                ))}
              </motion.div>

              <motion.div variants={fadeUp} className="mt-8 flex items-center gap-3">
                <img src={LaOc} alt="badge" className="h-10 w-auto" />
                <p className="text-sm tracking-[0.22em] text-slate-600">HOSPEDAJE INCLUIDO</p>
              </motion.div>
            </motion.div>

            <div className="lg:col-span-7">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <motion.div
                  variants={softIn}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.2 }}
                  className="md:row-span-2 rounded-[30px] overflow-hidden border border-slate-200 bg-white shadow-[0_30px_90px_rgba(2,6,23,0.10)]"
                >
                  <div className="relative h-full">
                    <motion.img
                      src={WholeHotel}
                      alt="Resort"
                      className="h-[520px] md:h-full w-full object-cover"
                      whileHover={{ scale: 1.03 }}
                      transition={{ duration: 0.6, ease: "easeOut" }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/0 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-7 md:p-8">
                      <p className="text-xs tracking-[0.30em] text-white/90">FRENTE AL MAR • TODO INCLUIDO</p>
                      <p className="mt-2 text-white/95 text-xl md:text-2xl font-light drop-shadow-[0_14px_34px_rgba(0,0,0,0.30)]">
                        Recarga en lujo entre sesiones.
                      </p>
                    </div>
                  </div>
                </motion.div>

                <motion.div
                  variants={softIn}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.2 }}
                  className="rounded-[30px] overflow-hidden border border-slate-200 bg-white shadow-[0_20px_70px_rgba(2,6,23,0.08)]"
                >
                  <div className="relative">
                    <motion.img
                      src={restaurants}
                      alt="Comidas"
                      className="h-[245px] w-full object-cover"
                      whileHover={{ scale: 1.04 }}
                      transition={{ duration: 0.6, ease: "easeOut" }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/0 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <p className="text-xs tracking-[0.30em] text-white/90">COMIDAS INCLUIDAS</p>
                      <p className="mt-2 text-white/95 text-sm drop-shadow-[0_12px_30px_rgba(0,0,0,0.28)]">
                        Varias opciones de restaurantes.
                      </p>
                    </div>
                  </div>
                </motion.div>

                <motion.div
                  variants={softIn}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.2 }}
                  className="rounded-[30px] overflow-hidden border border-slate-200 bg-white shadow-[0_20px_70px_rgba(2,6,23,0.08)]"
                >
                  <div className="relative">
                    <motion.img
                      src={LastOnyy}
                      alt="Amenidades"
                      className="h-[245px] w-full object-cover"
                      whileHover={{ scale: 1.04 }}
                      transition={{ duration: 0.6, ease: "easeOut" }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/0 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <p className="text-xs tracking-[0.30em] text-white/90">PLAYA &amp; AMENIDADES</p>
                      <p className="mt-2 text-white/95 text-sm drop-shadow-[0_12px_30px_rgba(0,0,0,0.28)]">
                        Espacio para relajarte y recargar.
                      </p>
                    </div>
                  </div>
                </motion.div>
              </div>

              <div className="mt-10 h-px w-full bg-gradient-to-r from-transparent via-blue-600/25 to-transparent" />
              <div className="-mt-px h-px w-full bg-gradient-to-r from-transparent via-red-600/20 to-transparent" />
            </div>
          </div>
        </div>
      </section>

      {/* ================= EXPERIENCIA (ENSAMBLES) ================= */}
      <section id="experience" className="relative w-full py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-[#EAF6FF] via-[#FFF3EC] to-[#F3FFF7]" />
          <div className="absolute -top-28 -left-32 h-[520px] w-[520px] rounded-full bg-blue-500/18 blur-3xl" />
          <div className="absolute -bottom-28 -right-32 h-[560px] w-[560px] rounded-full bg-red-500/14 blur-3xl" />
          <div className="absolute top-[30%] left-[55%] h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-amber-300/22 blur-3xl" />
          <div className="absolute inset-0 opacity-[0.10] bg-[repeating-linear-gradient(135deg,_rgba(15,23,42,0.45)_0px,_rgba(15,23,42,0.45)_1px,_transparent_1px,_transparent_14px)]" />
        </div>

        <div className="relative mx-auto max-w-7xl px-6 md:px-10 text-slate-900">
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.25 }} className="flex flex-col items-start">
            <motion.div variants={fadeUp} className="flex flex-wrap items-center gap-3">
              {[
                { dot: "bg-blue-600", label: "ENTRENAMIENTO MUSICAL" },
                { dot: "bg-red-600", label: "CULTURA + COMUNIDAD" },
                { dot: "bg-amber-500", label: "INMERSIÓN TOTAL" },
              ].map((x) => (
                <span
                  key={x.label}
                  className="inline-flex items-center rounded-full bg-white/75 backdrop-blur-md border border-white/60 px-4 py-2 shadow-[0_18px_55px_rgba(2,6,23,0.08)]"
                >
                  <span className={`mr-3 h-2.5 w-2.5 rounded-full ${x.dot}`} />
                  <span className="text-xs tracking-[0.34em] text-slate-700">{x.label}</span>
                </span>
              ))}
            </motion.div>

            <motion.h3 variants={fadeUp} className="mt-6 text-3xl md:text-5xl font-light tracking-wide">
              Tres grupos. Un solo sonido.
            </motion.h3>

            <motion.p variants={fadeUp} className="mt-4 text-slate-700 text-base md:text-lg max-w-3xl leading-relaxed">
              Energía dominicana, excelencia orquestal. Rota por tres formatos: acondicionamiento por secciones, dinamica de ensamble, y el poder de la orquesta completa.
            </motion.p>
          </motion.div>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                num: "01",
                tag: "SECCIONAL",
                title: "Acondicionamiento & Técnica",
                desc: "Trabajo diario: fundamentos, resistencia, articulación, precisión—subes tu nivel rápido.",
                img: SectionalPic,
                chip: "bg-blue-600",
                bar: "from-blue-600 via-sky-300 to-transparent",
              },
              {
                num: "02",
                tag: "ENSAMBLES",
                title: "Ensamble de Vientos + Cuerdas",
                desc: "Separados por familias—mezcla, escucha, lidera y fortalece tu identidad de sección.",
                img: AnsemblePic,
                chip: "bg-amber-500",
                bar: "from-amber-500 via-yellow-200 to-transparent",
              },
              {
                num: "03",
                tag: "ORQUESTA",
                title: "Sonido Unificado & Presentación",
                desc: "Todos juntos—balance, dirección y un sonido orquestal poderoso en vivo.",
                img: OrchestraPic,
                chip: "bg-red-600",
                bar: "from-red-600 via-rose-300 to-transparent",
              },
            ].map((c) => (
              <motion.div
                key={c.num}
                variants={softIn}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                className="group relative rounded-[28px] overflow-hidden bg-white/80 backdrop-blur-md border border-white/70 shadow-[0_28px_90px_rgba(2,6,23,0.10)]"
              >
                <div className="absolute top-4 left-4 z-10">
                  <div className="flex items-center gap-3 rounded-full bg-white/85 backdrop-blur-md border border-white/70 px-4 py-2 shadow-sm">
                    <span className={`h-2.5 w-2.5 rounded-full ${c.chip}`} />
                    <span className="text-xs tracking-[0.34em] text-slate-700">
                      {c.num} • {c.tag}
                    </span>
                  </div>
                </div>

                <div className="relative">
                  <motion.img
                    src={c.img}
                    alt={c.tag}
                    className="h-[250px] w-full object-cover"
                    whileHover={{ scale: 1.06 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/0 to-transparent" />
                </div>

                <div className="p-6">
                  <p className="text-lg font-light text-slate-900">{c.title}</p>
                  <p className="mt-3 text-slate-700 text-sm leading-relaxed">{c.desc}</p>
                  <div className={`mt-6 h-[10px] w-full rounded-full bg-gradient-to-r ${c.bar}`} />
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            variants={softIn}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            className="mt-12 rounded-[28px] border border-white/70 bg-white/75 backdrop-blur-md shadow-[0_26px_90px_rgba(2,6,23,0.08)] overflow-hidden"
          >
            <div className="grid grid-cols-1 md:grid-cols-3">
              {[
                { t: "Mañana", d: "Seccionales (acondicionamiento + técnica)", dot: "bg-blue-600" },
                { t: "Tarde", d: "Ensamble de vientos + cuerdas", dot: "bg-amber-500" },
                { t: "Noche", d: "Ensayo de orquesta completa", dot: "bg-red-600" },
              ].map((x, i) => (
                <div key={x.t} className="relative p-7 md:p-8">
                  {i !== 2 && <div className="hidden md:block absolute top-6 right-0 bottom-6 w-px bg-slate-200/70" />}
                  <div className="flex items-center gap-3">
                    <span className={`h-2.5 w-2.5 rounded-full ${x.dot}`} />
                    <p className="text-sm tracking-[0.22em] text-slate-900">{x.t}</p>
                  </div>
                  <p className="mt-3 text-slate-700 text-sm leading-relaxed">{x.d}</p>
                </div>
              ))}
            </div>
            <div className="h-[4px] w-full bg-gradient-to-r from-blue-600 via-amber-400 to-red-600" />
          </motion.div>
        </div>
      </section>

      {/* ================= EXCURSIONES ================= */}
      <section id="excursions" className="relative w-full bg-white text-slate-900 py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_15%,rgba(59,130,246,0.10),transparent_48%),radial-gradient(circle_at_85%_70%,rgba(245,158,11,0.10),transparent_45%),radial-gradient(circle_at_60%_95%,rgba(220,38,38,0.08),transparent_45%)]" />
          <div className="absolute inset-0 opacity-[0.05] bg-[repeating-linear-gradient(135deg,_rgba(15,23,42,0.75)_0px,_rgba(15,23,42,0.75)_1px,_transparent_1px,_transparent_16px)]" />
        </div>

        <div className="relative mx-auto max-w-7xl px-6 md:px-10">
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.25 }} className="max-w-3xl">
            <motion.div
              variants={fadeUp}
              className="inline-flex items-center gap-3 rounded-full border border-slate-200 bg-white/70 px-4 py-2 backdrop-blur-md shadow-sm"
            >
              <span className="h-2 w-2 rounded-full bg-amber-500" />
              <span className="text-xs tracking-[0.30em] text-slate-700">EXCURSIONES + VIDA DE RESORT</span>
            </motion.div>

            <motion.h3 variants={fadeUp} className="mt-6 text-3xl md:text-5xl font-light tracking-wide">
              El capítulo de la isla
            </motion.h3>

            <motion.p variants={fadeUp} className="mt-4 text-slate-700 text-base md:text-lg leading-relaxed">
              Después del concierto y la competencia, cambiamos el modo “performance” por la experiencia completa dominicana—una excursión final inolvidable, más cultura y actividades del resort durante la semana.
            </motion.p>
          </motion.div>

          <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-7 items-stretch">
            {/* ISLA SAONA */}
            <motion.div
              variants={softIn}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.2 }}
              className="lg:col-span-7 rounded-[34px] overflow-hidden border border-slate-200 bg-white shadow-[0_30px_90px_rgba(2,6,23,0.10)]"
            >
              <div className="relative">
                <motion.img
                  src={IslaSaona}
                  alt="Isla Saona"
                  className="h-[340px] md:h-[420px] w-full object-cover"
                  whileHover={{ scale: 1.03 }}
                  transition={{ duration: 0.7, ease: "easeOut" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />

                <div className="absolute top-5 left-5">
                  <div className="inline-flex items-center gap-3 rounded-full bg-white/85 backdrop-blur-md border border-white/70 px-4 py-2 shadow-sm">
                    <span className="h-2.5 w-2.5 rounded-full bg-blue-600" />
                    <span className="text-xs tracking-[0.34em] text-slate-800">DESTACADO • ISLA SAONA</span>
                  </div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <p className="text-white/90 text-xs tracking-[0.30em]">DÍA FINAL • TRANSPORTE PRIVADO DEL GRUPO</p>
                  <h4 className="mt-2 text-white text-2xl md:text-3xl font-light tracking-wide">
                    Un día completo en el paraíso
                  </h4>
                  <p className="mt-3 text-white/85 text-sm md:text-base max-w-xl leading-relaxed">
                    Cuando terminamos el concierto y la competencia, cerramos el festival con un día completo en Isla Saona—playa, descanso y celebración.
                  </p>

                  <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {["Bus privado + logística del grupo", "Día completo en la isla", "Celebración post-presentaciones"].map((t) => (
                      <div key={t} className="rounded-2xl bg-white/10 border border-white/15 backdrop-blur-md px-4 py-3">
                        <div className="flex items-start gap-3">
                          <span className="mt-1.5 h-2 w-2 rounded-full bg-blue-400" />
                          <p className="text-white/85 text-sm">{t}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="h-[5px] w-full bg-gradient-to-r from-blue-600 via-sky-300 to-amber-400" />
            </motion.div>

            {/* RIGHT STACK */}
            <div className="lg:col-span-5 grid grid-cols-1 gap-7">
              {/* Culture + Shopping */}
              <motion.div
                variants={softIn}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                className="rounded-[34px] overflow-hidden border border-slate-200 bg-white shadow-[0_30px_90px_rgba(2,6,23,0.10)]"
              >
                <div className="relative">
                  <motion.img
                    src={Shopping}
                    alt="Cultura + Compras"
                    className="h-[220px] w-full object-cover"
                    whileHover={{ scale: 1.04 }}
                    transition={{ duration: 0.7, ease: "easeOut" }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/0 to-transparent" />
                  <div className="absolute top-5 left-5">
                    <div className="inline-flex items-center gap-3 rounded-full bg-white/90 backdrop-blur-md border border-white/70 px-4 py-2 shadow-sm">
                      <span className="h-2.5 w-2.5 rounded-full bg-amber-500" />
                      <span className="text-xs tracking-[0.34em] text-slate-800">CULTURA + COMPRAS</span>
                    </div>
                  </div>
                </div>

                <div className="p-6 md:p-7">
                  <p className="text-xl font-light text-slate-900">Explora la cultura dominicana</p>
                  <p className="mt-3 text-slate-700 text-sm leading-relaxed">
                    Mercados, lugares locales y la energía de RD—una salida fácil y perfecta para el grupo.
                  </p>

                  <div className="mt-5 grid gap-2">
                    {["Mercados + compras", "Exploración cultural", "Tiempo en grupo"].map((b) => (
                      <div key={b} className="flex items-start gap-3">
                        <span className="mt-2 h-2 w-2 rounded-full bg-amber-500" />
                        <p className="text-slate-700 text-sm">{b}</p>
                      </div>
                    ))}
                  </div>

                  <div className="mt-6 h-[8px] w-full rounded-full bg-gradient-to-r from-amber-500 via-yellow-200 to-transparent" />
                </div>
              </motion.div>

              {/* Resort Activities */}
           
            </div>
          </div>

          {/* Timeline strip */}
          <motion.div
            variants={softIn}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            className="mt-10 rounded-[34px] border border-slate-200 bg-white/80 backdrop-blur-md shadow-[0_20px_70px_rgba(2,6,23,0.08)] overflow-hidden"
          >
            <div className="p-7 md:p-9">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                {[
                  { t: "Entrenamiento", d: "Seccionales + ensambles construyen la base.", dot: "bg-blue-600" },
                  { t: "Presentación", d: "Concierto + competencia para mostrar el trabajo.", dot: "bg-amber-500" },
                  { t: "Celebración", d: "Cultura + Isla Saona para cerrar la semana.", dot: "bg-red-600" },
                ].map((x, i) => (
                  <div key={x.t} className="flex items-start gap-4">
                    <div className="mt-1 flex flex-col items-center">
                      <span className={`h-3 w-3 rounded-full ${x.dot}`} />
                      {i !== 2 && <span className="hidden md:block mt-2 h-10 w-[2px] bg-slate-200" />}
                    </div>
                    <div>
                      <p className="text-sm tracking-[0.22em] text-slate-900">{x.t}</p>
                      <p className="mt-2 text-slate-700 text-sm leading-relaxed">{x.d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="h-[5px] w-full bg-gradient-to-r from-blue-600 via-amber-400 to-red-600" />
          </motion.div>
        </div>
      </section>

      {/* ================= FACULTAD (AUTO CAROUSEL) ================= */}
      <section id="faculty" className="relative w-full bg-white text-slate-900 py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 bg-gradient-to-br from-[#EAF6FF] via-[#FFF3EC] to-[#F3FFF7]" />
          <div className="absolute -top-28 -left-32 h-[520px] w-[520px] rounded-full bg-blue-500/18 blur-3xl" />
          <div className="absolute -bottom-28 -right-32 h-[560px] w-[560px] rounded-full bg-red-500/14 blur-3xl" />
          <div className="absolute top-[35%] left-[55%] h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-amber-300/22 blur-3xl" />
          <div className="absolute inset-0 opacity-[0.10] bg-[repeating-linear-gradient(135deg,_rgba(15,23,42,0.45)_0px,_rgba(15,23,42,0.45)_1px,_transparent_1px,_transparent_14px)]" />
        </div>

        <div className="relative mx-auto max-w-7xl px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
            <motion.div
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.25 }}
              className="lg:col-span-5 lg:sticky lg:top-28"
            >
              <motion.div
                variants={fadeUp}
                className="inline-flex items-center gap-3 rounded-full border border-white/70 bg-white/75 px-4 py-2 backdrop-blur-md shadow-[0_18px_55px_rgba(2,6,23,0.08)]"
              >
                <span className="h-2 w-2 rounded-full bg-amber-500" />
                <span className="text-xs tracking-[0.30em] text-slate-700">FACULTAD DE CLASE MUNDIAL</span>
              </motion.div>

              <motion.h3 variants={fadeUp} className="mt-6 text-3xl md:text-5xl font-light tracking-wide">
                Aprende con los mejores del mundo.
              </motion.h3>

              <motion.p variants={fadeUp} className="mt-4 text-slate-700 text-base md:text-lg leading-relaxed">
                Traemos maestros élite con <span className="text-slate-900">arte de nivel Grammy</span>, décadas de experiencia tocando y enseñando,
                y una profundidad real en pedagogía. Esto no es “campamento”—es un entorno de alto nivel donde tu interpretación sube rápido.
              </motion.p>

              <motion.div variants={fadeUp} className="mt-8 grid gap-3">
                {[
                  { dot: "bg-amber-500", t: "Reconocimiento y créditos profesionales de primer nivel" },
                  { dot: "bg-blue-600", t: "Décadas en escenario + resultados comprobados enseñando" },
                  { dot: "bg-red-600", t: "Altas expectativas, apoyo real y crecimiento serio" },
                ].map((x) => (
                  <div
                    key={x.t}
                    className="flex items-start gap-3 rounded-2xl border border-white/70 bg-white/75 backdrop-blur-md px-5 py-4 shadow-[0_18px_50px_rgba(2,6,23,0.08)]"
                  >
                    <span className={`mt-1.5 h-2 w-2 rounded-full ${x.dot}`} />
                    <p className="text-slate-700 text-sm md:text-base">{x.t}</p>
                  </div>
                ))}
              </motion.div>

              <motion.div variants={fadeUp} className="mt-8 flex flex-wrap gap-3">
                {[
                  { label: "MASTERCLASSES", dot: "bg-amber-500" },
                  { label: "COACHING SECCIONAL", dot: "bg-blue-600" },
                  { label: "MENTORÍA", dot: "bg-red-600" },
                  { label: "CARRERA/INDUSTRIA", dot: "bg-slate-500" },
                ].map((x) => (
                  <span
                    key={x.label}
                    className="inline-flex items-center rounded-full bg-white/75 backdrop-blur-md border border-white/70 px-4 py-2 shadow-[0_18px_55px_rgba(2,6,23,0.06)]"
                  >
                    <span className={`mr-3 h-2.5 w-2.5 rounded-full ${x.dot}`} />
                    <span className="text-xs tracking-[0.34em] text-slate-700">{x.label}</span>
                  </span>
                ))}
              </motion.div>

              <motion.p variants={fadeUp} className="mt-6 text-xs tracking-[0.30em] text-slate-600">
                DESLIZA • HOVER PARA PAUSAR
              </motion.p>
            </motion.div>

            <div className="lg:col-span-7">
              <motion.div
                variants={softIn}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                className="rounded-[34px] border border-white/70 bg-white/60 backdrop-blur-md shadow-[0_28px_90px_rgba(2,6,23,0.10)] overflow-hidden"
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
              >
                <div className="px-6 md:px-8 pt-6">
                  <div className="flex items-center justify-between gap-4">
                    <div className="inline-flex items-center gap-3 rounded-full border border-slate-200 bg-white/70 px-4 py-2 backdrop-blur-md shadow-sm">
                      <span className="h-2.5 w-2.5 rounded-full bg-blue-600" />
                      <span className="text-xs tracking-[0.34em] text-slate-700">FACULTY SPOTLIGHT</span>
                    </div>

                    <div className="hidden md:flex items-center gap-3 text-xs tracking-[0.28em] text-slate-500">
                      <span className="h-2 w-2 rounded-full bg-amber-500" />
                      <span>SWIPE</span>
                      <span className="h-2 w-2 rounded-full bg-blue-600" />
                      <span>SCROLL</span>
                      <span className="h-2 w-2 rounded-full bg-red-600" />
                    </div>
                  </div>
                </div>

                <div className="mt-6 pb-7">
                  <div className="px-6 md:px-8">
                    <div className="relative overflow-hidden rounded-[30px] bg-white/40 border border-white/70 shadow-[0_22px_70px_rgba(2,6,23,0.08)]">
                      <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-white/90 to-transparent z-10" />
                      <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-white/90 to-transparent z-10" />

                      <div className="overflow-hidden">
                        <div
                          className="flex gap-5 px-6 py-6"
                          style={{ transform: `translate3d(${-offset}px, 0, 0)`, willChange: "transform" }}
                        >
                          {loopFaculty.map((p, idx) => (
                            <div
                              key={`${p.name}-${idx}`}
                              ref={idx === 0 ? firstCardRef : null}
                              className="shrink-0 w-[82%] sm:w-[70%] md:w-[54%] lg:w-[58%] rounded-[28px] overflow-hidden border border-white/70 bg-white shadow-[0_28px_90px_rgba(2,6,23,0.12)]"
                            >
                              <div className="relative">
                                <motion.img
                                  src={p.img}
                                  alt={`${p.name} Facultad`}
                                  className="h-[420px] md:h-[460px] w-full object-cover"
                                  whileHover={{ scale: 1.02 }}
                                  transition={{ duration: 0.7, ease: "easeOut" }}
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />

                                <div className="absolute top-5 left-5 right-5 flex items-center justify-between gap-3">
                                  <div className="inline-flex items-center gap-3 rounded-full bg-white/80 border border-white/70 backdrop-blur-md px-4 py-2 shadow-sm">
                                    <span className={`h-2.5 w-2.5 rounded-full ${p.dot}`} />
                                    <span className="text-xs tracking-[0.34em] text-slate-800">FACULTY</span>
                                  </div>
                                  <span className="text-xs tracking-[0.30em] text-white/85 drop-shadow-[0_12px_30px_rgba(0,0,0,0.25)]">
                                    SIMANOF STANDARD
                                  </span>
                                </div>

                                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-7">
                                  <p className="text-white/95 text-2xl md:text-3xl font-light drop-shadow-[0_12px_30px_rgba(0,0,0,0.25)]">
                                    {p.name}
                                  </p>

                                  <div className="mt-3 flex flex-wrap gap-2">
                                    {p.role.map((c) => (
                                      <span
                                        key={c}
                                        className="inline-flex items-center rounded-full border border-white/25 bg-white/10 backdrop-blur-md px-3 py-1"
                                      >
                                        <span className="text-[10px] tracking-[0.32em] text-white/90">{c}</span>
                                      </span>
                                    ))}
                                  </div>

                                  <div className={`mt-6 h-[10px] w-full rounded-full bg-gradient-to-r ${p.bar}`} />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="px-6 pb-6">
                        <div className="h-[5px] w-full rounded-full bg-gradient-to-r from-blue-600/45 via-amber-400/40 to-red-600/40" />
                      </div>
                    </div>
                  </div>

                  <div className="mt-6 px-6 md:px-8">
                    <div className="h-[4px] w-full rounded-full bg-gradient-to-r from-blue-600/30 via-amber-400/25 to-red-600/25" />
                  </div>
                </div>
              </motion.div>

              <motion.div
                variants={softIn}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                className="mt-8 rounded-[30px] border border-white/70 bg-white/75 backdrop-blur-md shadow-[0_22px_80px_rgba(2,6,23,0.08)] overflow-hidden"
              >
                <div className="p-7 md:p-8 grid grid-cols-1 md:grid-cols-3 gap-6">
                  {[
                    { t: "Estándares Altos", d: "Expectativas claras, feedback real y crecimiento serio.", dot: "bg-blue-600" },
                    { t: "Experiencia Real", d: "Décadas tocando y enseñando a alto nivel.", dot: "bg-amber-500" },
                    { t: "Resultados Reales", d: "Técnica, confianza y liderazgo—día a día.", dot: "bg-red-600" },
                  ].map((x, i) => (
                    <div key={x.t} className="relative">
                      {i !== 2 && <div className="hidden md:block absolute top-1 right-[-12px] bottom-1 w-px bg-slate-200/70" />}
                      <div className="flex items-center gap-3">
                        <span className={`h-2.5 w-2.5 rounded-full ${x.dot}`} />
                        <p className="text-sm tracking-[0.22em] text-slate-900">{x.t}</p>
                      </div>
                      <p className="mt-3 text-slate-700 text-sm leading-relaxed">{x.d}</p>
                    </div>
                  ))}
                </div>
                <div className="h-[5px] w-full bg-gradient-to-r from-blue-600 via-amber-400 to-red-600" />
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= COMPETENCIA (LONDON TOUR) ================= */}
      <section id="competition" className="relative w-full bg-white text-slate-900 py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 bg-gradient-to-br from-[#EAF6FF] via-[#FFF3EC] to-[#F3FFF7]" />
          <div className="absolute -top-32 -left-32 h-[560px] w-[560px] rounded-full bg-blue-500/16 blur-3xl" />
          <div className="absolute -bottom-32 -right-40 h-[620px] w-[620px] rounded-full bg-red-500/14 blur-3xl" />
          <div className="absolute top-[35%] left-[65%] h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-amber-300/18 blur-3xl" />
          <div className="absolute inset-0 opacity-[0.08] bg-[repeating-linear-gradient(135deg,_rgba(15,23,42,0.45)_0px,_rgba(15,23,42,0.45)_1px,_transparent_1px,_transparent_16px)]" />
        </div>

        <div className="relative mx-auto max-w-7xl px-6 md:px-10">
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.25 }} className="max-w-3xl">
            <motion.div variants={fadeUp} className="inline-flex items-center gap-3 rounded-full border border-slate-200 bg-white/70 px-4 py-2 backdrop-blur-md shadow-sm">
              <span className="h-2 w-2 rounded-full bg-red-600" />
              <span className="text-xs tracking-[0.30em] text-slate-700">GRAN COMPETENCIA</span>
            </motion.div>

            <motion.h3 variants={fadeUp} className="mt-6 text-3xl md:text-5xl font-light tracking-wide">
              Gana tu Tour de Londres.
            </motion.h3>

            <motion.p variants={fadeUp} className="mt-4 text-slate-700 text-base md:text-lg leading-relaxed">
              11 de marzo · 9:00 a. m. – 1:00 p. m. Compite por el Tour de Londres gratis para el primer lugar, 50% de descuento para el segundo y 10% para el tercero.
            </motion.p>
            <motion.p variants={fadeUp} className="mt-4 text-base font-medium text-slate-800">
              La inscripción es gratis. Para participar, elige un ensayo el 9 o 10 de marzo y preséntate en el concierto.
            </motion.p>
            <Link to="/competencia" className="mt-6 inline-flex items-center justify-center rounded-2xl bg-blue-700 px-7 py-4 text-base font-semibold text-white shadow-lg transition hover:bg-blue-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-700">
              Inscribirme en la competencia →
            </Link>

          </motion.div>

          <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-7 items-stretch">
            {/* LEFT */}
            <motion.div
              variants={softIn}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.2 }}
              className="lg:col-span-4 rounded-[34px] border border-white/70 bg-white/75 backdrop-blur-md shadow-[0_26px_90px_rgba(2,6,23,0.08)] overflow-hidden"
            >
              <div className="p-7 md:p-8">
                <p className="text-xs tracking-[0.30em] text-slate-600">¿QUÉ SIGNIFICA?</p>
                <p className="mt-3 text-slate-900 text-xl font-light">Una oportunidad real. Un premio real.</p>

                <div className="mt-6 grid gap-3">
                  {[
                    { dot: "bg-amber-500", t: "Compite con propósito y toca bajo presión real." },
                    { dot: "bg-blue-600", t: "Evaluación en un entorno de alto nivel." },
                    { dot: "bg-red-600", t: "Ganadores reciben apoyo directo para Londres." },
                  ].map((x) => (
                    <div key={x.t} className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-white/70 backdrop-blur-md px-5 py-4 shadow-[0_18px_50px_rgba(2,6,23,0.06)]">
                      <span className={`mt-1.5 h-2 w-2 rounded-full ${x.dot}`} />
                      <p className="text-slate-700 text-sm leading-relaxed">{x.t}</p>
                    </div>
                  ))}
                </div>

                <div className="mt-7 h-[10px] w-full rounded-full bg-gradient-to-r from-blue-600 via-amber-400 to-red-600" />
              </div>

              <div className="h-[5px] w-full bg-gradient-to-r from-blue-600 via-amber-400 to-red-600" />
            </motion.div>

            {/* RIGHT: premios */}
            <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
              {/* 2nd */}
              <motion.div
                variants={softIn}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                className="relative rounded-[32px] border border-white/70 bg-white/80 backdrop-blur-md shadow-[0_28px_90px_rgba(2,6,23,0.10)] overflow-hidden"
              >
                <div className="p-7 md:p-8">
                  <div className="inline-flex items-center gap-3 rounded-full bg-white/80 border border-slate-200 px-4 py-2 backdrop-blur-md shadow-sm">
                    <span className="h-2.5 w-2.5 rounded-full bg-blue-600" />
                    <span className="text-xs tracking-[0.34em] text-slate-700">2DO LUGAR</span>
                  </div>

                  <p className="mt-6 text-4xl font-light text-slate-900">50%</p>
                  <p className="mt-2 text-sm tracking-[0.22em] text-slate-600">DE DESCUENTO EN EL TOUR DE LONDRES</p>

                  <p className="mt-6 text-slate-700 text-sm leading-relaxed">
                    Apoyo serio para hacer Londres realidad—gran ahorro para una gran oportunidad.
                  </p>

                  <div className="mt-8 h-[10px] w-full rounded-full bg-gradient-to-r from-blue-600 via-sky-300 to-transparent" />
                </div>
              </motion.div>

              {/* 1st */}
              <motion.div
                variants={softIn}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                className="relative rounded-[34px] border border-white/70 bg-white shadow-[0_36px_110px_rgba(2,6,23,0.14)] overflow-hidden md:-translate-y-2"
              >
                <div className="pointer-events-none absolute -inset-20 bg-[radial-gradient(circle_at_50%_30%,rgba(245,158,11,0.20),transparent_55%),radial-gradient(circle_at_25%_80%,rgba(59,130,246,0.14),transparent_55%),radial-gradient(circle_at_80%_85%,rgba(220,38,38,0.12),transparent_55%)]" />

                <div className="relative p-7 md:p-8">
                  <div className="flex items-center justify-between gap-3">
                    <div className="inline-flex items-center gap-3 rounded-full bg-white/85 border border-slate-200 px-4 py-2 backdrop-blur-md shadow-sm">
                      <span className="h-2.5 w-2.5 rounded-full bg-amber-500" />
                      <span className="text-xs tracking-[0.34em] text-slate-700">1ER LUGAR</span>
                    </div>
                    <span className="text-xs tracking-[0.30em] text-slate-500">GRAN PREMIO</span>
                  </div>

                  <p className="mt-6 text-5xl font-light text-slate-900">100%</p>
                  <p className="mt-2 text-sm tracking-[0.22em] text-slate-600">DEL TOUR DE LONDRES</p>

                  <p className="mt-6 text-slate-700 text-sm leading-relaxed">
                    Cobertura total del Tour de Londres—el premio mayor. Da el paso, gana y vívelo.
                  </p>

                  <div className="mt-8 h-[10px] w-full rounded-full bg-gradient-to-r from-amber-500 via-yellow-200 to-transparent" />
                </div>

                <div className="h-[5px] w-full bg-gradient-to-r from-blue-600 via-amber-400 to-red-600" />
              </motion.div>

              {/* 3rd */}
              <motion.div
                variants={softIn}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.2 }}
                className="relative rounded-[32px] border border-white/70 bg-white/80 backdrop-blur-md shadow-[0_28px_90px_rgba(2,6,23,0.10)] overflow-hidden"
              >
                <div className="p-7 md:p-8">
                  <div className="inline-flex items-center gap-3 rounded-full bg-white/80 border border-slate-200 px-4 py-2 backdrop-blur-md shadow-sm">
                    <span className="h-2.5 w-2.5 rounded-full bg-red-600" />
                    <span className="text-xs tracking-[0.34em] text-slate-700">3ER LUGAR</span>
                  </div>

                  <p className="mt-6 text-4xl font-light text-slate-900">10%</p>
                  <p className="mt-2 text-sm tracking-[0.22em] text-slate-600">DE DESCUENTO EN EL TOUR DE LONDRES</p>

                  <p className="mt-6 text-slate-700 text-sm leading-relaxed">
                    Un descuento fuerte y un impulso real hacia tu siguiente nivel en tour.
                  </p>

                  <div className="mt-8 h-[10px] w-full rounded-full bg-gradient-to-r from-red-600 via-rose-300 to-transparent" />
                </div>
              </motion.div>
            </div>
          </div>

          {/* Bottom strip */}
          <motion.div
            variants={softIn}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            className="mt-10 rounded-[34px] border border-white/70 bg-white/75 backdrop-blur-md shadow-[0_20px_70px_rgba(2,6,23,0.08)] overflow-hidden"
          >
            <div className="p-7 md:p-9 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              {[
                { dot: "bg-amber-500", t: "CLARO Y JUSTO", d: "Estándares claros y evaluación real." },
                { dot: "bg-blue-600", t: "ALTO IMPACTO", d: "Una oportunidad que te cambia la vida." },
                { dot: "bg-red-600", t: "¿LISTO?", d: "Aplica, prepárate y toma tu oportunidad." },
              ].map((x) => (
                <div key={x.t} className="flex items-start gap-4">
                  <span className={`mt-1.5 h-3 w-3 rounded-full ${x.dot}`} />
                  <div>
                    <p className="text-sm tracking-[0.22em] text-slate-900">{x.t}</p>
                    <p className="mt-2 text-slate-700 text-sm leading-relaxed">{x.d}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="h-[5px] w-full bg-gradient-to-r from-blue-600 via-amber-400 to-red-600" />
          </motion.div>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className="relative bg-white text-slate-900">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-14">
          <div className="rounded-[34px] border border-slate-200 bg-white/75 backdrop-blur-md shadow-[0_22px_80px_rgba(2,6,23,0.08)] overflow-hidden">
            <div className="p-8 md:p-10">
              <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
                <div className="md:col-span-5">
                  <div className="inline-flex items-center gap-3 rounded-full border border-slate-200 bg-white/80 px-4 py-2 backdrop-blur-md shadow-sm">
                    <span className="h-2 w-2 rounded-full bg-blue-600" />
                    <span className="text-xs tracking-[0.30em] text-slate-700">SIMANOF</span>
                  </div>

                  <p className="mt-5 text-2xl md:text-3xl font-light tracking-wide text-slate-900">
                    Simanof Festival • República Dominicana
                  </p>

                  <p className="mt-4 text-slate-700 text-sm md:text-base leading-relaxed max-w-md">
                    Una experiencia de alto nivel: entrenamiento, presentaciones, competencia y cultura.
                    Todo en un solo lugar—Punta Cana.
                  </p>

                  <div className="mt-8">
                  <div className="mt-8">
  <Link
    to="/tour-form"
    className="inline-flex items-center justify-center rounded-md px-9 py-3
               border border-slate-300 bg-white/70 backdrop-blur-md
               hover:bg-white hover:border-slate-400
               transition duration-300 tracking-[0.22em] text-xs md:text-sm text-slate-900
               transform hover:scale-[1.04] active:scale-[0.98]"
  >
    APLICA AHORA
  </Link>
</div>
                  </div>
                </div>

                <div className="md:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
                  <div>
                    <p className="text-xs tracking-[0.30em] text-slate-600">SECCIONES</p>
                    <div className="mt-4 grid gap-3 text-sm text-slate-700">
                      {[
                        { label: "Resort", href: "#about" },
                        { label: "Experiencia", href: "#experience" },
                        { label: "Excursiones", href: "#excursions" },
                        { label: "Facultad", href: "#faculty" },
                        { label: "Competencia", href: "#competition" },
                      ].map((x) => (
                        <a key={x.label} href={x.href} className="hover:text-slate-900 transition">
                          {x.label}
                        </a>
                      ))}
                    </div>
                  </div>

                  <div>
                    <p className="text-xs tracking-[0.30em] text-slate-600">CONTACTO</p>
                    <div className="mt-4 grid gap-3 text-sm text-slate-700">
                      <a href="mailto:information@simanof.org" className="hover:text-slate-900 transition">
                        information@simanof.org
                      </a>
                      <a href="https://www.instagram.com/simanof_/" target="_blank" rel="noreferrer" className="hover:text-slate-900 transition">
                        @simanof_

                      </a>
                      <p className="text-slate-600">Punta Cana, República Dominicana</p>
                    </div>
                  </div>

                  <div className="col-span-2 md:col-span-1">
                    <p className="text-xs tracking-[0.30em] text-slate-600">LEGAL</p>
                    <div className="mt-4 grid gap-3 text-sm text-slate-700">
                      <p className="text-slate-600">Itinerario sujeto a cambios.</p>
                      <p className="text-slate-600">Términos y condiciones disponibles bajo solicitud.</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-10 h-px w-full bg-gradient-to-r from-transparent via-blue-600/20 to-transparent" />
              <div className="-mt-px h-px w-full bg-gradient-to-r from-transparent via-red-600/15 to-transparent" />

              <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <p className="text-xs tracking-[0.26em] text-slate-600">
                  © {new Date().getFullYear()} SIMANOF. TODOS LOS DERECHOS RESERVADOS.
                </p>
                <div className="flex items-center gap-4 text-xs tracking-[0.26em] text-slate-600">
                  <a href="#apply" className="hover:text-slate-900 transition">APLICAR</a>
                  <span className="opacity-40">•</span>
                  <a href="#competition" className="hover:text-slate-900 transition">COMPETENCIA</a>
                  <span className="opacity-40">•</span>
                  <a href="#faculty" className="hover:text-slate-900 transition">FACULTAD</a>
                </div>
              </div>
            </div>

            <div className="h-[5px] w-full bg-gradient-to-r from-blue-600 via-amber-400 to-red-600" />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomiePagie;
